/* eslint-disable react/button-has-type */
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';
import Popup from '../../shared/Popup';
import { deleteCookie } from '../../../utils/helpers';
import Spinner from '../../../icons/spinner';

// eslint-disable-next-line react/prop-types
function Logout({ isVisible, onClose }) {
  // const [showPopup, setShowPoup] = useState(isVisible);
  const handleClose = () => {
    onClose();
    // setShowPoup(false);
  };

  return (
    <Popup
      showPopup={isVisible}
      popupFor="Logout"
      divwidth="w-full lg:w-auto lg:max-w-[95%]"
      onPopupClose={() => handleClose}
      messageData={<LogoutContent handleClose={handleClose} />}
    />

  );
}

// eslint-disable-next-line react/prop-types
export function LogoutContent({ handleClose }) {
  const [loader, setLoader] = useState(false);

  const clearSession = () => {
    window.localStorage.clear();
    deleteCookie('userToken');
    deleteCookie('userDamsToken');
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 200);
  };

  const handleClick = (input) => {
    if (input === 'no') {
      handleClose();
    } else {
      setLoader(true);
      clearSession();
    }
  };
  return (
    <div className="w-full text-center">
      <p className="text-2xl font-bold pb-5">Logout</p>
      <p className="text-xl pb-4 text-[#414141]">Are you sure want to logout?</p>
      <div className="flex justify-between items-center gap-2">
        <button
          onClick={() => handleClick('yes')}
          className={`w-full p-2 rounded-md border border-[#939393] text-[#939393] hover:bg-customBlue hover:text-white ${loader ? 'flex justify-center bg-customBlue cursor-not-allowed' : ''}`}
        >
          {
            loader ? (<Spinner />) : 'Yes'
              }

        </button>
        <button
          onClick={() => handleClick('no')}
          className="bg-customBlue w-full p-2 rounded-md text-white"
        >
          No
        </button>
      </div>
    </div>
  );
}

export default Logout;
